interface GameTable2DProps {
  round: number;
}

export function GameTable2D({ round }: GameTable2DProps) {
  return (
    <div className="pointer-events-none absolute left-1/2 top-1/2 h-[58%] w-[58%] -translate-x-1/2 -translate-y-1/2">
      <div className="relative h-full w-full rounded-full border-4 border-amber-900/50 bg-gradient-to-br from-emerald-900/80 to-emerald-950 shadow-inner">
        <div className="absolute inset-[12%] rounded-full border border-white/10 bg-emerald-800/30" />
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-center">
          {round > 0 && (
            <p className="text-sm font-semibold text-amber-200/90">라운드 {round}</p>
          )}
          <p className="text-[10px] uppercase tracking-[0.25em] text-white/40">Mission Dice Poker</p>
        </div>
      </div>
    </div>
  );
}
